// eslint-disable-next-line no-unused-vars
import React, { createContext, useReducer, useEffect } from 'react';
import _ from 'lodash';
import { Context } from 'shared/types';
import englishMessages from 'translations/en.json';
import AppReducer from '../reducers/index';
import { loadState, saveState } from './localStorage';

const persistedState = loadState();

export const defaultClient = {
  token: '',
  email: '',
  phone: '',
  session: '',
};

export const initialState = {
  rootState: {
    language: { locale: 'en', messages: englishMessages },
    clientData: (persistedState && persistedState.clientData) || defaultClient,
  },
  dashboard: {
    summary: [],
    detail: {},
    languageRemote: {},
  },
};

export const GlobalContext = createContext<Context>({ state: initialState, dispatch: () => {} });

export const GlobalProvider: React.FC = ({ children }): JSX.Element => {
  const [state, dispatch] = useReducer(AppReducer, initialState);
  useEffect(_.throttle(() => {
    saveState({
      ...persistedState,
      clientData: state.rootState.clientData,
    });
  }, 1000), [state]);

  return (
    <GlobalContext.Provider value={{ state, dispatch }}>
      {children}
    </GlobalContext.Provider>
  );
};
